export default {"src":"/_next/static/media/unq.99997fbe.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};